import { checkIfHasOrderToPrint, calcTotalUnitsOfOrder } from '../domain';

import { orderToPrintAdapter } from './orderToPrint.adapter';
import { orderToPrintRepository } from './ordenToPrint.repository';

import type { OrderIdForcedProps } from '../domain';

export function orderToPrintService(props?: OrderIdForcedProps) {
  const { orderIdForced = NaN } = props ?? {};

  const orderIdToPrint = orderToPrintRepository.getOrderID();
  const isRenderForced =
    Boolean(orderIdForced) && orderToPrintRepository.getIsRenderForced();

  const orderId = isRenderForced ? orderIdForced : orderIdToPrint;
  const order = orderToPrintAdapter.toPrintOrder(
    orderToPrintRepository.getOrderDetail(orderId),
  );

  return {
    isRenderForced,
    order,
    // default value is NaN
    orderId: order.id,
    hasOrderToPrint: !isRenderForced && checkIfHasOrderToPrint(order),
    calcTotalUnitsOfOrder,
    confirmOrderPrinting: orderToPrintRepository.updateOrderHasBeenPrinted,
  };
}
